import React from 'react';
import { connect } from 'react-redux';
import { makeGetTaskCustomFieldValue } from '../../../../../redux/tasks/taskEntities/selectors';
import ConnectedTaskWorkspaceCustomFieldValue from './ConnectedTaskWorkspaceCustomFieldValue';

const ConnectedTaskCustomField = ({ customFieldId, customFieldValue, isWorkspaceCustomField, projectId }) => {
  if (!customFieldValue) return null;
  
  return isWorkspaceCustomField ? (
    <div className="flex flex-row align-center">
      {Array.isArray(customFieldValue) ? (
        customFieldValue.map((customFieldValueItem, idx) => (
          <ConnectedTaskWorkspaceCustomFieldValue
            key={customFieldValueItem?._id || customFieldValueItem?.assigneeId || idx}
            customFieldId={customFieldId}
            customFieldValueId={customFieldValueItem}
            projectId={projectId}
          />
        ))
      ) : (
        <ConnectedTaskWorkspaceCustomFieldValue
          customFieldId={customFieldId}
          customFieldValueId={customFieldValue}
          projectId={projectId}
        />
      )}
    </div>
  ) : (
    <div className='text-center text-sm'>
      {typeof customFieldValue === 'object' ? customFieldValue?.label || customFieldValue?.email || null : customFieldValue}
    </div>
  );
};

const makeMapStateToProps = () => {
  const getTaskCustomFieldValue = makeGetTaskCustomFieldValue();
  return (state, props) => ({
    customFieldValue: getTaskCustomFieldValue(state, props),
  });
};

export default connect(makeMapStateToProps)(ConnectedTaskCustomField);
